import { render } from "./whdHeatWorkData.vue?vue&type=template&id=06db5dc2&scoped=true"
import script from "./whdHeatWorkData.vue?vue&type=script&lang=js"
export * from "./whdHeatWorkData.vue?vue&type=script&lang=js"

import "./whdHeatWorkData.vue?vue&type=style&index=0&id=06db5dc2&scoped=true&lang=css"

import exportComponent from "D:\\A_Projcets_Code\\mes-chunyu\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06db5dc2"]])

export default __exports__